document.addEventListener('DOMContentLoaded', function () {
    const variantSelectors = document.querySelectorAll('.select__select');
    const sizePickerButton = document.getElementById('size-picker-button');
    const selectDiamondButtons = $('.select-diamond-button');
    const sizeRadioButtons = document.querySelectorAll('.size-radiobutton');
    let allValuesSelected = false; // Flag to track if all values are selected
    window.selectedSize = ''; // Global variable to store the selected size

    // Function to check if all variant selectors have a selected value and are not disabled
    function areAllValuesSelected() {
        const metalSelected = Array.from(variantSelectors).every(function (selector) {
            return selector.value !== '' && selector.value !== 'Choose Metal';
        });
        const sizeSelected = typeof window.selectedSize !== 'undefined' && window.selectedSize !== '' && window.selectedSize !== 'Choose Size';
        return metalSelected && sizeSelected;
    }

    // Function to update button class and onclick event based on selected values
    function updateButtonState() {
        allValuesSelected = areAllValuesSelected();
        selectDiamondButtons.each(function () {
            const button = $(this);
            if (allValuesSelected) {
                button.addClass('variant-selected'); // Add variant-selected class
                button.off('click').on('click', function (event) {
                    event.preventDefault(); // Prevent redirection
                    showDiamondSelectionPopup(); // Show popup
                }); // Assign the function to onclick event
            } else {
                button.removeClass('variant-selected'); // Remove variant-selected class
                button.off('click').on('click', function (event) {
                    event.preventDefault(); // Prevent default behavior
                    showAlert(); // Show alert if values are not selected
                }); // Assign the function to onclick event
            }
        });
    }

    // Add click event listener to each variant selector
    variantSelectors.forEach(function (variantSelector) {
        variantSelector.addEventListener('click', function () {
            removePopup(variantSelector); // Remove popup associated with the clicked variant selector
            updateButtonState();
        });
    });

    // Add click event listener to size picker button
    if (sizePickerButton) {
        sizePickerButton.addEventListener('click', function () {
            removePopup(sizePickerButton); // Remove popup associated with the size picker button
        });
    }

    // Add change event listener to size radio buttons
    sizeRadioButtons.forEach(function (sizeRadioButton) {
        sizeRadioButton.addEventListener('change', function () {
            window.selectedSize = this.value;
            updateButtonState();
        });
    });

    // Function to show a popup above variant selectors with not selected values
    function showPopups() {
        $('.variant-popup').remove();

        // Define messages for different conditions
        const messages = {
            '': 'Please select a value',
            'Choose Metal': 'Your selection of metal type is required',
            'Choose Size': 'Your choice of finger size is required'
        };

        variantSelectors.forEach(function (variantSelector) {
            // Get the message based on the value of the variantSelector
            const message = messages[variantSelector.value];
            if (message) {
                const popup = $('<div>').addClass('variant-popup').text(message);
                popup.appendTo($(variantSelector).closest('.select'));
                popup.fadeIn('slow');
            }
        });

        // Check the size picker button
        if (typeof window.selectedSize === 'undefined' || window.selectedSize === '') {
            const message = messages['Choose Size'];
            const popup = $('<div>').addClass('variant-popup').text(message);
            const sizePickerContainer = $(sizePickerButton).closest('.size-picker-container');
            sizePickerContainer.prepend(popup);
            popup.fadeIn('slow');
        }
    }

    // Modified showAlert function to show popups
    function showAlert() {
        // Remove existing popups
        removeAllPopups();

        // Show new popups
        showPopups();

        // Calculate the position of the point where the alert will be centered
        const alertPosition = $('.variant-popup').first().offset().top - ($(window).height() / 3);

        // Scroll the page to the calculated position
        window.scrollTo({
            top: alertPosition,
            behavior: 'smooth'
        });
    }

    // Function to show the diamond selection popup with fadeIn
    function showDiamondSelectionPopup() {
        $('#diamond-selection-popup').fadeIn('fast'); // Adjust 'fast' to your preferred speed
        $('body').css('overflow', 'hidden'); // Disable scrolling
    }

    // Function to hide the diamond selection popup with fadeOut
    function hideDiamondSelectionPopup() {
        $('#diamond-selection-popup').fadeOut('fast', function () {
            $('body').css('overflow', ''); // Enable scrolling after fade out is complete
        });
    }

    // Add click event listener to the "Select Diamond" button
    selectDiamondButtons.on('click', function (event) {
        event.preventDefault(); // Prevent default behavior
        if (areAllValuesSelected()) {
            showDiamondSelectionPopup(); // Show popup if all values are selected
        } else {
            showAlert(); // Show alert if values are not selected
        }
    });

    // Add click event listener to close the popup when clicking outside
    $(document).on('click', function (event) {
        const popupContent = $('.diamond-selection-popup-content');
        const isOutsidePopup = popupContent.length > 0 && !popupContent.is(event.target) && popupContent.has(event.target).length === 0 && !$(event.target).is('.select-diamond-button');

        if (isOutsidePopup) {
            hideDiamondSelectionPopup();
        }
    });

    // Initial button state update
    updateButtonState();

    // Function to remove all popups
    function removeAllPopups() {
        $('.variant-popup').fadeOut('slow', function () {
            $(this).remove();
        });
    }

    // Function to remove popup associated with a specific element
    function removePopup(element) {
        const closestPopup = $(element).closest('.select, .size-picker-container').find('.variant-popup');
        if (closestPopup.length) {
            // Only fade out if the closest popup exists
            closestPopup.stop(true, true).fadeOut('slow', function () {
                $(this).remove();
            });
        }
    }

    // Trigger the change event for the default size radio button to ensure button state updates
    const defaultSizeRadioButton = document.querySelector('input[name="properties[Size]"][value="6"]');
    if (defaultSizeRadioButton) {
        defaultSizeRadioButton.dispatchEvent(new Event('change'));
    }
});
